import Icon from "@visa/vds/icon";
import React from "react";

const PostTypeIcon = (props) => {
  let iconName = "";
  switch (props.type) {
    case 1:
      if (props.fileExtension === ".pdf") {
        iconName = "document-pdf";
      } else {
        iconName = "report";
      }
      break;
    case 2:
      iconName = "link";
      break;
    default:
      break;
  }

  return (
    <Icon className="library-post-type-icon" name={iconName} resolution="low" />
  );
};

export default PostTypeIcon;
